'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalInstance = exports.shouldBind = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setAsLatestInstance = setAsLatestInstance;
exports.setInternalInstance = setInternalInstance;
exports.inheritMethodsFromInternalInstance = inheritMethodsFromInternalInstance;

var _ramda = require('ramda');

var _inheritance = require('./inheritance');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// only bind sender methods to internalInstance
// bind getter/setter methods feels like a too strong assumption
// and might introduce confusion
var shouldBind = exports.shouldBind = (0, _ramda.startsWith)('send');

var InternalInstance = exports.InternalInstance = function () {
  function InternalInstance(bindings, services) {
    _classCallCheck(this, InternalInstance);

    this.__latestInstance__ = null;
    this.__bindings__ = this.buildBindingMethods(bindings);
    this.__services__ = this.buildServices(services);
  }

  // eslint-disable-next-line class-methods-use-this


  _createClass(InternalInstance, [{
    key: 'hasOwnProperty',
    value: function hasOwnProperty(key) {
      // don't return __latestInstance__ since it will cause cycle reference
      return key === '__bindings__' || key === '__services__';
    }
  }, {
    key: 'setLatestInstance',
    value: function setLatestInstance(instance) {
      this.__latestInstance__ = instance;
      return this;
    }
  }, {
    key: 'getLatestInstance',
    value: function getLatestInstance() {
      return this.__latestInstance__;
    }
  }, {
    key: 'hasBinding',
    value: function hasBinding(name) {
      return this.__bindings__[name] !== undefined;
    }
  }, {
    key: 'getBinding',
    value: function getBinding(name) {
      return this.__bindings__[name];
    }
  }, {
    key: 'getBindings',
    value: function getBindings() {
      return this.__bindings__;
    }
  }, {
    key: 'buildBindingMethods',
    value: function buildBindingMethods(bindings) {
      var _this = this;

      return (0, _ramda.reduce)(function (memo, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            bindingName = _ref2[0],
            bindingValue = _ref2[1];

        if ((0, _ramda.is)(Function, bindingValue) && shouldBind(bindingName)) {
          return _extends({}, memo, _defineProperty({}, bindingName, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return bindingValue.apply(_this.getLatestInstance(), args);
          }));
        } else {
          return memo;
        }
      }, {}, (0, _ramda.toPairs)(bindings));
    }
  }, {
    key: 'buildServices',
    value: function buildServices(services) {
      var _this2 = this;

      return (0, _ramda.reduce)(function (memo, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            serviceName = _ref4[0],
            createService = _ref4[1];

        return _extends({}, memo, _defineProperty({}, serviceName, createService(function () {
          return _this2.__latestInstance__;
        })));
      }, {}, (0, _ramda.toPairs)(services));
    }
  }, {
    key: 'getService',
    value: function getService(name) {
      return this.__services__[name];
    }
  }, {
    key: 'getServices',
    value: function getServices() {
      return this.__services__;
    }
  }]);

  return InternalInstance;
}();

function setAsLatestInstance(model) {
  model.__internalInstance__.setLatestInstance(model);
}

function setInternalInstance(model, internalInstance) {
  if (!internalInstance) {
    // set internal instance as early as possible
    model.__internalInstance__ = new InternalInstance((0, _inheritance.getAllFunctions)(model), model.constructor.services).setLatestInstance(model);
  } else {
    model.__internalInstance__ = internalInstance;
  }
}

function inheritMethodsFromInternalInstance(model) {
  (0, _ramda.forEach)(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        name = _ref6[0],
        value = _ref6[1];

    model[name] = value;
  }, (0, _ramda.toPairs)(model.__internalInstance__.getBindings()));
}